import React, { useEffect } from 'react'
import styles from './Avatar.module.scss';
import classNames from 'classnames/bind';
let cx = classNames.bind(styles);

export default function Avatar({src , status, reminder, size , alt}:any) {
  let badgeStatus = cx({
      badge: true,
      active: status === 'Available',
      offline: status === 'UnAvailable', 
      busy: status === 'Busy',
  }); 

  const avatarColors = ['#A145FF', '#155EEF', '#53CA43', '#3E4784', '#FA6298', '#F79009', '#B42318', '#747480']
  const avatarSize = { "--size": size? `${size/16}rem` : '2.5rem' } as React.CSSProperties;
  let i = alt? alt.length:  0;

  const getAvatarColor = ()=>{
    if(alt?.length) {
      while (i > avatarColors.length) {
        i = Math.round(i / 2);
      }
    }
    return avatarColors[i];
  }
  const avatarColor = { "background": getAvatarColor() } as React.CSSProperties;

  const getAvatarName = ()=>{
    let shortName = '';
    if(alt){
      const fullName = alt.split(' ');
      shortName = fullName[0][0] + fullName[(fullName.length - 1)][0];
    }
    return shortName;
  }

  return (
    <div className={styles.avatar} style={avatarSize}>
        
        {  !src || src === null || src === undefined || src === '' ? 
          (<span style={avatarColor} className={styles.avatarPlaceholder}>{getAvatarName()}</span>)
          : 
          ( <img src={src} className={styles.avatarImage} alt={alt} /> )
        }

        {status && <span className={badgeStatus}></span>}
        
        {reminder && <span className={styles.avatarBadge}>1</span>}
        
    </div>
  )
}
